// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.share-card-tab {
  padding: 8px 12px;
}

.social-network-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.social-network-button {
  width: 100%;
  height: 48px;
  display: flex;
  align-items: center;
  border-radius: 8px;
  border-width: 0px;
  justify-content: flex-start;
}

.social-network-button__content {
    display: flex;
    align-items: center;
    gap: 8px;
  }

.vk-button {
  background-color: #0077ff;
}

.vk-button__title {
    color: #ffffff;
  }

.telegram-button {
  background-color: #19a6e0;
}

.telegram-button__title {
    color: #ffffff;
  }

.ok-button {
  background-color: #f7931e;
}

.ok-button:hover,
  .ok-button:active,
  .ok-button:focus {
    background-color: #ffa34d;
  }

.ok-button__title {
    color: #ffffff;
  }
`, "",{"version":3,"sources":["webpack://./src/components/Module/RecordCard/ShareTab/style.scss"],"names":[],"mappings":"AAEA;EACE,iBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAgC;EAChC,iBAAiB;EACjB,2BAA2B;AAO7B;;AALE;IACE,aAAa;IACb,mBAAmB;IACnB,QAAY;EACd;;AAGF;EACE,yBAAyB;AAK3B;;AAHE;IACE,cAAa;EACf;;AAGF;EACE,yBAAyB;AAK3B;;AAHE;IACE,cAAa;EACf;;AAGF;EACE,yBAAyB;AAW3B;;AATE;;;IAGE,yBAAyB;EAC3B;;AAEA;IACE,cAAa;EACf","sourcesContent":["@import '../../../../../assets/scss/variables.scss';\n\n.share-card-tab {\n  padding: $sm-gap $md-gap;\n}\n\n.social-network-list {\n  display: flex;\n  flex-direction: column;\n  gap: $sm-gap;\n}\n\n.social-network-button {\n  width: 100%;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  border-radius: $md-border-radius;\n  border-width: 0px;\n  justify-content: flex-start;\n\n  &__content {\n    display: flex;\n    align-items: center;\n    gap: $sm-gap;\n  }\n}\n\n.vk-button {\n  background-color: #0077ff;\n\n  &__title {\n    color: $white;\n  }\n}\n\n.telegram-button {\n  background-color: #19a6e0;\n\n  &__title {\n    color: $white;\n  }\n}\n\n.ok-button {\n  background-color: #f7931e;\n\n  &:hover,\n  &:active,\n  &:focus {\n    background-color: #ffa34d;\n  }\n\n  &__title {\n    color: $white;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
